/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Equivalence_IssInputs */

const en_us2_equivalence_iss = /** @type {(inputs: Equivalence_IssInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`the weight of the International Space Station`);
	return /** @type {LocalizedString} */ (`the weight of ${i?.amount} space stations`)
	
};

const pt_br2_equivalence_iss = /** @type {(inputs: Equivalence_IssInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso da Estação Espacial Internacional`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} Estações Espaciais`)
	
};

const es_419_equivalence_iss = /** @type {(inputs: Equivalence_IssInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`el peso de la Estación Espacial Internacional`);
	return /** @type {LocalizedString} */ (`el peso de ${i?.amount} estaciones espaciales`)
	
};

const pt_pt2_equivalence_iss = /** @type {(inputs: Equivalence_IssInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso da Estação Espacial Internacional`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} estações espaciais`)
	
};

const fr_fr2_equivalence_iss = /** @type {(inputs: Equivalence_IssInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`le poids de la Station spatiale internationale`);
	return /** @type {LocalizedString} */ (`le poids de ${i?.amount} stations spatiales`)
	
};

const de_de2_equivalence_iss = /** @type {(inputs: Equivalence_IssInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`das Gewicht der Internationalen Raumstation`);
	return /** @type {LocalizedString} */ (`das Gewicht von ${i?.amount} Raumstationen`)
	
};

const it_it2_equivalence_iss = /** @type {(inputs: Equivalence_IssInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`il peso della Stazione Spaziale Internazionale`);
	return /** @type {LocalizedString} */ (`il peso di ${i?.amount} stazioni spaziali`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "the weight of the International Space Station" |
* | * | "the weight of {amount} space stations" |
*
* @param {Equivalence_IssInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equivalence_iss = /** @type {((inputs: Equivalence_IssInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equivalence_IssInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equivalence_iss(inputs)
	if (locale === "es-419") return es_419_equivalence_iss(inputs)
	if (locale === "pt-PT") return pt_pt2_equivalence_iss(inputs)
	if (locale === "fr-FR") return fr_fr2_equivalence_iss(inputs)
	if (locale === "de-DE") return de_de2_equivalence_iss(inputs)
	if (locale === "it-IT") return it_it2_equivalence_iss(inputs)
	return en_us2_equivalence_iss(inputs)
});
export { equivalence_iss as "equivalence.iss" }